<template>
    <div
        class="py-12 bg-gray-700 transition duration-150 ease-in-out z-10 absolute top-0 right-0 bottom-0 left-0"
        id="modal"
    >
        <div role="alert" class="container mx-auto w-11/12 md:w-2/3 max-w-lg">
            <div
                class="relative py-8 px-5 md:px-10 bg-white shadow-md rounded border border-gray-400"
            >
                <div class="w-full flex justify-start text-gray-600 mb-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        width="52"
                        height="52"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 256 256"
                    >
                        <path
                            fill="currentColor"
                            d="M168 56a8 8 0 0 1 8-8h16V32a8 8 0 0 1 16 0v16h16a8 8 0 0 1 0 16h-16v16a8 8 0 0 1-16 0V64h-16a8 8 0 0 1-8-8Zm62.7 55.6A99.8 99.8 0 0 1 232 128a103.7 103.7 0 0 1-33.8 76.7l-1.3 1.2a104 104 0 0 1-137.8 0l-1.3-1.2A104 104 0 0 1 128 24a99.8 99.8 0 0 1 16.4 1.3a8 8 0 0 1-2.5 15.8A92 92 0 0 0 128 40a88 88 0 0 0-65.8 146.4a79.2 79.2 0 0 1 36.1-28.7a48 48 0 1 1 59.4 0a79.2 79.2 0 0 1 36.1 28.7A87.6 87.6 0 0 0 216 128a92 92 0 0 0-1.1-13.9a8 8 0 0 1 15.8-2.5ZM128 152a32 32 0 1 0-32-32a32.1 32.1 0 0 0 32 32Zm0 64a87.4 87.4 0 0 0 53.9-18.5a64 64 0 0 0-107.8 0A87.4 87.4 0 0 0 128 216Z"
                        ></path>
                    </svg>
                </div>
                <h1
                    class="text-gray-800 font-lg font-bold tracking-normal leading-tight mb-4"
                >
                    Edit User Details
                </h1>
                <div v-if="error" class="my-6">
                    <p class="text-xs text-red-500 font-semibold">
                        {{ error }}
                    </p>
                </div>
                <label
                    for="name"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >Name</label
                >
                <input
                    required
                    v-model="form.name"
                    id="name"
                    autocomplete="name"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    placeholder="Name"
                />
                <label
                    for="email"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >Email</label
                >
                <input
                    type="email"
                    v-model="form.email"
                    required
                    autocomplete="email"
                    id="email"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    placeholder="Email"
                />

                <label
                    for="role"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >Role</label
                >
                <select
                    id="role"
                    required
                    v-model="form.role"
                    name="role"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                >
                    <option value="client">Client</option>
                    <option value="support">Support</option>
                    <option value="analyst">Analyst</option>
                    <option value="elo">Elo</option>
                    <option value="manager">Manager</option>
                    <option value="admin">Admin</option>
                </select>
                <label
                    for="status"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >Status</label
                >
                <select
                    id="status"
                    required
                    v-model="form.status"
                    name="status"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                >
                    <option value="">Select a Status</option>
                    <option value="active">Active</option>
                    <option value="archived">Archived</option>
                    <option value="disabled">Disabled</option>
                    <option value="suspended">Suspended</option>

                </select>
                <label
                    for="password"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >New Password</label
                >
                <input
                    type="password"
                    v-model="form.password"
                    id="password"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                />
                <label
                    for="password_confirmation"
                    class="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >Confirm Password</label
                >
                <input
                    type="password"
                    v-model="form.password_confirmation"
                    id="password_confirmation"
                    class="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                />

                <div class="flex items-center justify-start w-full">
                    <button
                        @click="modifyUser"
                        class="focus:outline-none transition duration-150 ease-in-out hover:bg-green-600 bg-green-700 rounded text-white px-8 py-2 text-sm"
                    >
                        Save Changes
                    </button>
                    <button
                        class="focus:outline-none ml-3 bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm"
                        @click="$emit('close')"
                    >
                        Cancel
                    </button>
                </div>
                <div
                    class="cursor-pointer absolute top-0 right-0 mt-4 mr-5 text-gray-400 hover:text-gray-600 transition duration-150 ease-in-out"
                    @click="$emit('close')"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Close"
                        class="icon icon-tabler icon-tabler-x"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        stroke-width="2.5"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditUser",
    props: {
        role: {
            type: String,
            default: "client",
        },
        item: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            error: null,
            form: {
                id: this.item.id,
                name: this.item.name,
                email: this.email,
                region: this.item.region_code,
                password: "",
                password_confirmation: "",
                role: this.role,
                status: "",
            },
        };
    },
    mounted() {
        this.form.name = this.item.name;
        this.form.email = this.item.email;
        this.form.status = this.item.status.value ?? "";
        this.form.password = "";
        this.form.password_confirmation = "";
    },
    methods: {
        modifyUser() {
            if (
                this.form.password.length > 0 &&
                this.form.password !== this.form.password_confirmation
            ) {
                this.error = "Passwords do not match";
                return;
            }

            if (
                this.form.status.length === 0
            ) {
                this.error = "Please select a status";
                return;
            }

            if (
                this.form.password.length > 0 &&
                this.form.password.length < 10
            ) {
                this.error = "Password must be at least 10 characters";
                return;
            }

            axios
                .patch(`/users/${this.item.id}`, this.form)
                .then((response) => {
                    this.$emit("submit", "updated");
                    this.modalHandler();
                })
                .catch(({ response }) => {
                    this.error = response.data.message;
                });
        },
        modalHandler(val) {
            let modal = document.getElementById("modal");
            if (val) {
                this.fadeIn(modal);
            } else {
                this.fadeOut(modal);
            }
        },
        fadeOut(el) {
            el.style.opacity = 1;
            (function fade() {
                if ((el.style.opacity -= 0.1) < 0) {
                    el.style.display = "none";
                } else {
                    requestAnimationFrame(fade);
                }
            })();
        },
        fadeIn(el, display) {
            el.style.opacity = 0;
            el.style.display = display || "flex";
            (function fade() {
                let val = parseFloat(el.style.opacity);
                if (!((val += 0.2) > 1)) {
                    el.style.opacity = val;
                    requestAnimationFrame(fade);
                }
            })();
        },
    },
};
</script>
